// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dg-0";
export var actionModalContentContainer = "_dg-1";